module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-introduction element-with-heading",
    attrs: {
      "id": "introduction"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-mixed"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "element-subtitle case-upper"
  }, [_vm._v("FAMILIAR TERRITORY")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "introduction-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Animals and magic go together like pen and paper, books and a warm beverage … writers and cats. We, the editors of this anthology, know that last to be particularly true. We have seven cats between us. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Which is why when our fifth cohort of Publishing graduate students earning their Master of Arts degree at Western Colorado University settled on "), _c('i', [_vm._v("Feisty Felines and Other Fantastical Familiars")]), _vm._v(" for their group thesis project, we knew they were on to something. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("These fifteen students developed the call for submissions and spent their fall semester wading through the slush pile to find the best familiar stories. And as it turns out, we had not only a clowder of cat stories to choose from but also a plethora of creative familiar stories. So, after careful consideration and much discussion, this anthology holds to its name: about half of the stories are about feline familiars and half are about other animal familiars. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("These stories range from light to dark, with several poems threaded through, but all adhere to our most important criterion: that the familiar be the main voice.  ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The students then arranged the stories, worked with the authors on copy edits, chose the art for the cover, and assisted in all aspects of production and marketing. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("So, thanks to the hard work of these Publishing MA students, and generous funding from Draft2Digital, "), _c('i', [_vm._v("Feisty Felines")]), _vm._v(" joins the previous Western Colorado University anthology projects: "), _c('i', [_vm._v("Monsters, Movies & Mayhem ")]), _vm._v("(winner of the 2021 Colorado Book Award for Best Anthology);"), _c('i', [_vm._v(" Unmasked; Gilded Glass; ")]), _vm._v("and"), _c('i', [_vm._v(" Merciless Mermaids. ")]), _vm._v("Like its predecessors, this book contains an incredible collection of fantastic stories. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("We hope you enjoy reading them as much as we all enjoyed working with them. But don’t be surprised if once you’re done reading this anthology, you find yourself seeking out your own fantastical familiar.…")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—Kevin J. Anderson and Allyson Longueira")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("Graduate Program in Creative Writing")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("Western Colorado University")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ddb4def","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 69
// module chunks = 0